import { TaskType } from "enums/TaskType.enum";
// import { Assignment } from "types/assignment.type";
import { Task } from "types/task.type";
import { JaNejStatus, SeparatorClassification } from "../enums";
import { isBefore } from "date-fns";
import { Facility } from "types/facility.type";
import { ActivityType } from "enums/ActivityType.enum";
import { AvskiljareTomning } from "types/waste.type";
import {
  WaterMeasurementPointData,
  waterMeasurementPointDataSchema,
} from "./waterMeasurementPointData.type";
import { z } from "zod";
import { WaterMeasurementProtocol } from "types/waterMeasurementProtocol/waterMeasurementProtocol.type";

export type Separator = {
  id: number;
  type: SeparatorType;
  identifier: string;
  propertyDesignation?: string;
  slamMaxLevel?: number;
  oilMaxLevel?: number;
  manufacturer?: string;
  yearOfManufacture?: string;
  marking858?: JaNejStatus;
  verification858?: JaNejStatus;
  verification858Text?: string;
  provtagningsbrunnFinns?: JaNejStatus;
  nivalarmFinns?: JaNejStatus;
  notes: string;
  slamnivalarmFinns?: JaNejStatus;
  damningslarmHognivalarmFinns?: JaNejStatus;
  koalecensfilterFinns?: JaNejStatus;
  classification?: SeparatorClassification;
  modelIdentifier?: string;
  shapeCylindric?: boolean;
  shapeRectangular?: boolean;
  shapeStandingUp?: boolean;
  shapeLyingDown?: boolean;
  shapeOther?: boolean;
  description: string;
  facility: Facility;
  shapeOtherValue?: string;
  flottarFinns?: JaNejStatus;
  flottarDensitetAngiven?: string;
  totalVatskevolym?: string;
  maxSlamvolym?: string;
  fritextType: string;
  maxOljevolym?: string;
  avtalSlamtomning?: boolean;
  avtalFemarskontroll?: boolean;
  avtalHalvarsKontroll?: boolean;
  tomningReminder?: BooleanMonthList;
  flode?: string;
  coordinates?: string;
  createdAt: Date;
  files: SeparatorFile[];
  isDeleted: boolean;
  tasks?: Task[];
  address?: string;
  postalCode?: string;
  city?: string;
  kommunKod: string;
  cfarNR?: string;
  uuid: string;
  uppgiftList: Uppgift[];
  waterMeasurementPointData?: WaterMeasurementPointData;
  avtalVattenprovtagning?: boolean;
  vattenprovtagningMonths: BooleanMonthList;
  /** Första planerade femårsbesiktning ('YYYY-MM-15') när historik saknas. */
  initialFemarsKontrollDate?: string | null;
  /** Första planerade sexmånaderskontroll ('YYYY-MM-15') när historik saknas. */
  initialHalvarsKontrollDate?: string | null;
};

export type SeparatorFile = {
  id: number;
  name: string;
  url: string;
};

export type Uppgift = {
  id: number;
  type: ActivityType;
  inspectionDate: Date;
  tomning?: AvskiljareTomning;
  uppdragUuid: string;
};

export type CreateSeparatorDTO = {
  type: SeparatorType;
  identifier?: string;
  propertyDesignation?: string;
  slamMaxLevel?: number;
  oilMaxLevel?: number;
  manufacturer?: string;
  yearOfManufacture?: string;
  marking858?: JaNejStatus;
  description: string;
  verification858?: JaNejStatus;
  verification858Text?: string;
  provtagningsbrunnFinns?: JaNejStatus;
  nivalarmFinns?: JaNejStatus;
  notes: string;
  slamnivalarmFinns?: JaNejStatus;
  damningslarmHognivalarmFinns?: JaNejStatus;
  koalecensfilterFinns?: JaNejStatus;
  classification?: SeparatorClassification;
  modelIdentifier?: string;
  shapeCylindric?: boolean;
  fritextType: string;
  shapeRectangular?: boolean;
  shapeStandingUp?: boolean;
  shapeLyingDown?: boolean;
  avtalSlamtomning?: boolean;
  avtalFemarskontroll?: boolean;
  avtalHalvarsKontroll?: boolean;
  avtalSlamtomningAntalPerAr?: number;
  shapeOtherValue?: string;
  shapeOther?: boolean;
  flottarFinns?: JaNejStatus;
  flottarDensitetAngiven?: string;
  totalVatskevolym?: string;
  coordinates?: string;
  maxSlamvolym?: string;
  maxOljevolym?: string;
  flode?: string;
  customerId: number;
  nextSlamtomningReminder?: Date;
  address?: string;
  postalCode?: string;
  city?: string;
  cfarNR?: string;
  kommunKod: string;
  waterMeasurementPointData?: WaterMeasurementPointData;
  vattenprovtagningMonths: BooleanMonthList;
};

export type UpdateSeparatorDTO = {
  type: SeparatorType;
  identifier?: string;
  propertyDesignation?: string;
  slamMaxLevel?: number;
  oilMaxLevel?: number;
  manufacturer?: string;
  yearOfManufacture?: string;
  description: string;
  marking858?: JaNejStatus;
  verification858?: JaNejStatus;
  verification858Text?: string;
  provtagningsbrunnFinns?: JaNejStatus;
  nivalarmFinns?: JaNejStatus;
  notes: string;
  slamnivalarmFinns?: JaNejStatus;
  damningslarmHognivalarmFinns?: JaNejStatus;
  koalecensfilterFinns?: JaNejStatus;
  classification?: SeparatorClassification;
  modelIdentifier?: string;
  shapeCylindric?: boolean;
  fritextType: string;
  shapeRectangular?: boolean;
  shapeStandingUp?: boolean;
  shapeLyingDown?: boolean;
  shapeOther?: boolean;
  shapeOtherValue?: string;
  flottarFinns?: JaNejStatus;
  coordinates?: string;
  flottarDensitetAngiven?: string;
  totalVatskevolym?: string;
  maxSlamvolym?: string;
  maxOljevolym?: string;
  flode?: string;
  avtalSlamtomning?: boolean;
  avtalFemarskontroll?: boolean;
  avtalHalvarsKontroll?: boolean;
  avtalSlamtomningAntalPerAr?: number;
  tomningReminder?: BooleanMonthList;
  avtalVattenprovtagning?: boolean;
  vattenprovtagningMonths: BooleanMonthList;
  address?: string;
  postalCode?: string;
  city?: string;
  kommunKod: string;
  waterMeasurementPointData?: WaterMeasurementPointData;
};

export enum SeparatorType {
  Oil = "Oil",
  Slam = "Slam",
  OilAndSlam = "OilAndSlam",
  Tvattranna = "Tvattranna",
  Fritext = "Fritext",
  WaterMeasurementPoint = "WaterMeasurementPoint",
}

export type BooleanMonthList = {
  january: boolean;
  february: boolean;
  march: boolean;
  april: boolean;
  may: boolean;
  june: boolean;
  july: boolean;
  august: boolean;
  september: boolean;
  october: boolean;
  november: boolean;
  december: boolean;
};

export const booleanMonthListSchema = z.object({
  january: z.boolean().optional().default(false),
  february: z.boolean().optional().default(false),
  march: z.boolean().optional().default(false),
  april: z.boolean().optional().default(false),
  may: z.boolean().optional().default(false),
  june: z.boolean().optional().default(false),
  july: z.boolean().optional().default(false),
  august: z.boolean().optional().default(false),
  september: z.boolean().optional().default(false),
  october: z.boolean().optional().default(false),
  november: z.boolean().optional().default(false),
  december: z.boolean().optional().default(false),
});

export const getNextSeparatorTaskDate = (
  separator: Separator,
  taskType: TaskType,
): Date | undefined => {
  if (!separator) {
    return undefined;
  }
  return (separator.tasks ?? [])
    .sort((a: Task, b: Task) =>
      isBefore(new Date(a.date), new Date(b.date)) ? -1 : 1,
    )
    .find((task: Task) => task.type === taskType)?.date;
};

export const hasAvtal = (separator: Separator) =>
  separator.avtalFemarskontroll ||
  separator.avtalHalvarsKontroll ||
  separator.avtalSlamtomning ||
  separator.avtalVattenprovtagning;

export const isAvskiljare = (separator?: Separator) =>
  !separator
    ? false
    : [
        SeparatorType.Oil,
        SeparatorType.OilAndSlam,
        SeparatorType.Slam,
      ].includes(separator.type);

export const isWaterMeasurementPoint = (separator?: Separator) =>
  separator?.type === SeparatorType.WaterMeasurementPoint;

export const patchSeparatorDTOSchema = z.object({
  type: z.nativeEnum(SeparatorType).optional(),
  identifier: z.string().optional(),
  description: z.string().optional(),
  propertyDesignation: z.string().optional(),
  fritextType: z.string().optional(),
  notes: z.string().optional(),
  coordinates: z.string().optional(),
  avtalSlamtomning: z.boolean().optional(),
  avtalVattenprovtagning: z.boolean().optional(),
  avtalFemarskontroll: z.boolean().optional(),
  avtalHalvarsKontroll: z.boolean().optional(),
  tomningReminder: booleanMonthListSchema.optional(),
  vattenprovtagningMonths: booleanMonthListSchema.optional(),
  ignoredHalvarsKontrollDate: z.string().nullable().optional(),
  ignoredFemarsKontrollDate: z.string().nullable().optional(),
  ignoredTomningDate: z.string().nullable().optional(),
  ignoredVattenprovtagningDate: z.string().nullable().optional(),
  waterMeasurementPointData: waterMeasurementPointDataSchema.optional(),
  initialFemarsKontrollDate: z.string().nullable().optional(),
  initialHalvarsKontrollDate: z.string().nullable().optional(),
});

export type PatchSeparatorDTO = z.infer<typeof patchSeparatorDTOSchema>;
